import { render, staticRenderFns } from "./ExamenPage.vue?vue&type=template&id=73090fe6&scoped=true"
import script from "./ExamenPage.vue?vue&type=script&lang=js"
export * from "./ExamenPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73090fe6",
  null
  
)

export default component.exports